import { Col, Row, Table } from 'react-bootstrap';
import RadioInput from '../common/radio';
//import { SelfAccountUnlockFormFields } from 'src/constants';

import './SelfAccountUnlock.scss';

const IdentificationFields = ({
  SelfAccountUnlockFormFields,
  values,
  setFieldValue,
}) => {
  return (
    <Row className="open-enrollment-approval Payment-details section-separator-border">
      <Col md={5} lg={5} sm={5} className="padding-0">
        <h3>Required Identification</h3>
        <p>
          Define additional fields that will identify the Members in the portal.
          <br />A maximum 6 fields can be selected.{' '}
        </p>
      </Col>
      <Col md={7} lg={7} sm={7}>
        <Table className="m-0">
          <thead>
            <tr>
              <th className="text-left pl-5 w-50">Field</th>
              <th className="text-left pl-5">Required</th>
            </tr>
          </thead>
          <tbody>
            {SelfAccountUnlockFormFields.map((item, index) => (
              <tr key={index}>
                <td className="text-left pl-5">{item.label}</td>
                <td className="text-left pl-5">
                  <Row className="pt-2">
                    <Col>
                      <RadioInput
                        id={`${item.value}Yes`}
                        label="Yes"
                        name={item.value}
                        value="Visible"
                        checked={
                          values[item.value] === 'Visible' ||
                          values[item.value] === ''
                        }
                        onChange={(e) =>
                          setFieldValue(item.value, e.target.value)
                        }
                      />
                    </Col>
                    <Col className="approval-enroll">
                      <RadioInput
                        id={`${item.value}No`}
                        label="No"
                        name={item.value}
                        value="InVisible"
                        checked={values[item.value] === 'InVisible'}
                        onChange={(e) =>
                          setFieldValue(item.value, e.target.value)
                        }
                      />
                    </Col>
                    <Col className="approval-enroll">
                      <RadioInput
                        id={`${item.value}Hide`}
                        label="Hide"
                        name={item.value}
                        value="hide"
                        checked={values[item.value] === 'hide'}
                        onChange={(e) =>
                          setFieldValue(item.value, e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};

export default IdentificationFields;
